import React from "react";

const COLORS = ["#FF007F", "#00FFFF", "#FFD700", "#39FF14", "#A020F0"];

export default function Confetti({ count = 48 }) {
  const pieces = React.useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        key: i,
        left: Math.random() * 100,
        delay: Math.random() * 0.8,
        duration: 1.8 + Math.random() * 1.6,
        color: COLORS[i % COLORS.length],
        size: 6 + Math.random() * 8,
        rot: Math.random() * 360,
      })),
    [count]
  );

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {pieces.map((p) => (
        <div
          key={p.key}
          style={{
            position: "absolute",
            left: `${p.left}%`,
            top: "-20px",
            width: p.size,
            height: p.size * 0.4,
            background: p.color,
            boxShadow: `0 0 8px ${p.color}`,
            animation: `confetti-fall ${p.duration}s linear ${p.delay}s forwards`,
            transform: `rotate(${p.rot}deg)`,
          }}
        />
      ))}
    </div>
  );
}
